import { type RevisionPageLink, RevisionPageType } from '../types';
import { randomUUID } from '../utils';

/**
 * Create a page link.
 */
export function createPageLink(
    parts: Pick<RevisionPageLink, 'title' | 'target'> & Partial<RevisionPageLink>
): RevisionPageLink {
    return {
        type: RevisionPageType.Link,
        ...parts,
        id: parts.id ?? randomUUID(),
        edits: parts.edits ?? {},
    };
}
